<template>
  <div class="custom-tree-container">
    <el-tree
      ref="tree"
      :data="tree"
      default-expand-all
      node-key="id"
      show-checkbox
      :props="defaultProps"
      :expand-on-click-node="false"
    ></el-tree>
  </div>
</template>

<script>
export default {
  props: {
      defaultTree:Array
  },
  data() {
    return {
      tree: [],
      defaultProps: {
        children: "children",
        label: "label"
      }
    };
  },
  methods: {
    query() {
      var self = this;
      this.$axios.get("system/permission/tree").then(function(response) {
        if (response.data.errorCode == "00000") {
          self.tree = response.data.data;
        } else {
          self.$message.error(response.data.errorMsg);
        }
      });
    },
    getChecked() {
      return this.$refs.tree
        .getCheckedKeys()
        .concat(this.$refs.tree.getHalfCheckedKeys());
    },
    setChecked(data) {
      this.$refs.tree.setCheckedKeys([]);
      var that = this;
      data.forEach(i => {
        var node = that.$refs.tree.getNode(i);
        console.log(node.isLeaf);
        if (node.isLeaf) {
          that.$refs.tree.setChecked(node, true);
        }
      });
    }
  },
  created: function() {
    // this.query();
    this.tree = this.defaultTree;
  }
};
</script>

<style>
</style>